import { useState, useMemo, createElement } from 'react';
import { ModalProps } from 'semantic-ui-react';

import Confirm, { Props } from 'src/components/applications/Confirm';

type UseConfirm = Props & Omit<ModalProps, 'onOpen' | 'onClose'>;

const useConfirm = (defaultProps?: UseConfirm) => {
  const [confirmProps, setConfirmProps] = useState<UseConfirm | undefined>(
    defaultProps,
  );
  const [isOpen, setOpen] = useState<boolean>(defaultProps?.isOpen || false);

  return useMemo(() => {
    return {
      isOpen,
      close: () => {
        confirmProps?.onCancel?.();
        setOpen(false);
      },
      open: (props?: UseConfirm) => {
        setConfirmProps(props);
        const onOpen = props?.onOpen || confirmProps?.onOpen;
        onOpen?.();
        setOpen(true);
      },
      Confirm: (props: UseConfirm) =>
        createElement(Confirm, {
          ...confirmProps,
          ...props,
          isOpen,
          onCancel: () => {
            const onCancel = props?.onCancel || confirmProps?.onCancel;
            onCancel?.();
            setOpen(false);
          },
          async onOk() {
            const onOK = props?.onOk || confirmProps?.onOk;
            await onOK?.();
            setOpen(false);
          },
        }),
    };
  }, [confirmProps, isOpen]);
};

export default useConfirm;
